export class AttendeeDto {
  email: string
  name: string

  constructor(params?: { email: string; name: string }) {
    if (params) {
      this.email = params.email != null ? params.email : null
      this.name = params.name != null ? params.name : null
    }
  }
}

export class AttendeeModel {
  id: string
  email: string
  name: string
  validatedAt?: number
  hours?: number
  eventId?: string
  eventName?: string
  // Row left by a deleted account: no name, no e-mail, random key.
  anonymized?: boolean
  // Set on the shared "Törölt résztvevők" row the admin shows instead of the single anonymous rows.
  count?: number

  constructor(params?: {
    id: string
    email: string
    name: string
    validatedAt?: number
    eventId?: string
    eventName?: string
    anonymized?: boolean
    count?: number
  }) {
    if (params) {
      this.id = params.id != null ? params.id : ''
      this.email = params.email != null ? params.email : ''
      this.name = params.name != null ? params.name : ''
      if (params.validatedAt !== undefined) {
        this.validatedAt = params.validatedAt
      }
      if (params.eventId !== undefined) {
        this.eventId = params.eventId
      }
      if (params.eventName !== undefined) {
        this.eventName = params.eventName
      }
      if (params.anonymized) {
        this.anonymized = true
      }
      if (params.count !== undefined) {
        this.count = params.count
      }
    }
  }
}
